module.exports = __webpack_public_path__ + "files/ef894fa0f0b3c2646aa2428608789f2b.png";